import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Dropdown from '@tekion/tekion-components/src/molecules/DropDown';
import FontIcon from '@tekion/tekion-components/src/atoms/FontIcon';
import { EMPTY_STRING } from 'tbase/app.constants';
import ButtonRole from '../../atoms/ButtonRole';
import { DEFAULT_COLORS } from './ColorPicker.constants';
import styles from './ColorPicker.module.scss';
const ColorPicker = _ref => {
  let {
    children,
    colorPickerClassName,
    trigger,
    disabled,
    placement,
    colors,
    selectedColor,
    onSelectColor,
    title
  } = _ref;
  const menu = useMemo(() => /*#__PURE__*/React.createElement("div", {
    className: styles.colorPickerOptions
  }, colors.map(color => /*#__PURE__*/React.createElement(ButtonRole, {
    key: color,
    style: {
      background: color
    },
    className: styles.color,
    onClick: () => onSelectColor({
      colorCode: color
    })
  }, selectedColor === color && /*#__PURE__*/React.createElement(FontIcon, {
    className: styles.tickIcon
  }, "icon-tick1")))), [colors, onSelectColor, selectedColor]);
  return /*#__PURE__*/React.createElement(Dropdown, {
    trigger: trigger,
    disabled: disabled,
    overlay: menu,
    placement: placement
  }, children || /*#__PURE__*/React.createElement("div", {
    style: {
      background: selectedColor
    },
    className: cx(colorPickerClassName, styles.colorPicker),
    title: title || EMPTY_STRING
  }));
};
ColorPicker.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onSelectColor: PropTypes.func.isRequired,
  colorPickerClassName: PropTypes.string,
  disabled: PropTypes.bool,
  placement: PropTypes.string,
  trigger: PropTypes.array,
  selectedColor: PropTypes.string,
  colors: PropTypes.array,
  title: PropTypes.string
};
ColorPicker.defaultProps = {
  placement: 'bottomLeft',
  colorPickerClassName: '',
  disabled: false,
  trigger: ['click'],
  selectedColor: EMPTY_STRING,
  colors: DEFAULT_COLORS,
  title: EMPTY_STRING
};
export default ColorPicker;